import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import s from 'components/bolt/header/header.sss';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import Store from 'store/store';


export default class Header extends BaseComp.default {
	renderExtraActions() {
		const headerLogo = this.props.appData?.header?.powsterHeader?.logo?.src;

		return (
			<img
				class={s.logo}
				src={headerLogo}
				alt="United Artists Releasing Logo"
				onClick={() => Store.emit('SET_ACTIVE_PAGE', 'landing')}
			/>
		);
	}

	render(props, state) {
		if (!Store.get().client?.isDesktopSize) {
			return super.render(props, state);
		}

		const headerLogo = props.appData?.header?.powsterHeader?.logo?.src;
		const pages = props.appData?.header?.powsterHeader?.nav || {};
		const activePage = props.activePage;
		const isNewsPage = activePage === 'news';
		const isAboutPage = activePage === 'about';
		return (
			<header class={joinClasses(s.wrapper, (isNewsPage || isAboutPage) && s.newsPage)}>
				<img onClick={() => Store.emit('SET_ACTIVE_PAGE', 'landing')} class={s.logo} src={headerLogo} alt="United Artists Releasing Logo" />
				<nav class={s.nav}>
					{sortObjectByOrder(pages).map(element => (
						<button
							class={joinClasses(s.link, element.path === activePage && s.active)}
							onClick={() => Store.emit('SET_ACTIVE_PAGE', element.path)}
						>
							{element.name}
						</button>
					))}
				</nav>
			</header>
		);
	}
}
